import { render } from "./ModuleSelectionPage.vue?vue&type=template&id=ea4a2f22&scoped=true"
import script from "./ModuleSelectionPage.vue?vue&type=script&lang=js"
export * from "./ModuleSelectionPage.vue?vue&type=script&lang=js"

import "./ModuleSelectionPage.vue?vue&type=style&index=0&id=ea4a2f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea4a2f22"]])

export default __exports__